"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH = void 0;
const driverFieldMaxLength_1 = require("../../driverFieldMaxLength");
exports.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH = {
    SOURCE_EXTERNAL_ID: 100,
    DRIVER_ID: driverFieldMaxLength_1.DRIVER_FIELD_MAX_LENGTH.EXTERNAL_DRIVER_ID,
    DRIVING_STATISTICS: 512,
    TASK_ID: 100,
    ROUTE_SETTINGS: 200,
    ROUTE_SOURCE: 50,
    COPILOT_PROFILE: 1000,
};
//# sourceMappingURL=platformScienceTraceFieldMaxLength.js.map